if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.scrollBy = 5;
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            gallery: this.querySelector('[id^="Slider-Gallery"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
            sideThumbnails: this.querySelector('[id^=GalleryThumbnails-Side]'),
            images: this.querySelector('[id^="Slider-Gallery"]').querySelectorAll('[id^="Slide-"]'),
            dots: this.querySelector('[id^="Slider-Thumbnails"]'),
            prevButton: this.querySelector('[id^="GalleryThumbnails-Side"]').querySelector('button[name="previous"]'),
            nextButton: this.querySelector('[id^="GalleryThumbnails-Side"]').querySelector('button[name="next"]')
          };
          this.currentSidebarIndex = 0;
          if (this.elements.prevButton) {
            this.elements.prevButton.addEventListener('click', () => this.onButtonClick('previous'));
          }
          if (this.elements.nextButton) {
            this.elements.nextButton.addEventListener('click', () => this.onButtonClick('next'));
          }

          if (this.elements.sideThumbnails) {
            this.elements.sideThumbnails.addEventListener('scroll', this.handleScroll.bind(this));
          }

          this.mql = window.matchMedia('(min-width: 750px)');
          if (!this.elements.thumbnails) return;

          this.media = this.elements.thumbnails.querySelectorAll('[data-target]');
          this.sidebarMedia = this.elements.sideThumbnails.querySelectorAll('[data-target]');

          this.sidebarMediaList = this.elements.sideThumbnails.querySelector('[id^="Slider-Thumbnails"]');

          [...this.media, ...this.sidebarMedia].forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
          
          this.elements.dots.querySelectorAll('[data-dot-index]').forEach((dot, idx) => {
            dot.addEventListener('click', () => {
              this.setActiveMedia.bind(this, this.media[idx].dataset.target, false);
            });
          })
          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
          this.elements.gallery.addEventListener('scroll', debounce(() => {
            const scrolledTo = this.elements.gallery.scrollLeft;
          
            this.elements.images.forEach((image) => {
              if (image.offsetLeft === scrolledTo) {
                this.setActiveMedia(image.dataset.mediaId, false);
              }
            })
          }, 50));

          window.addEventListener('resize', () => {

            requestAnimationFrame(() => {
              const activeMedia = this.elements.viewer.querySelector('.is-active');

              this.elements.gallery.scrollLeft = activeMedia.offsetLeft;
            })
          })
        }

        handleScroll() {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => this.onScrollComplete(), 150);
        }

       scrollToIndex (index) {
          if (!this.sidebarMedia) {
            return;
          }
          if (index >= 0 && index <= this?.sidebarMedia?.length) {
            this.currentSidebarIndex = index;
            this.elements.sideThumbnails.classList.toggle('hasPrevious', index > 0);
            this.elements.sideThumbnails.classList.toggle('hasNext', index < this?.sidebarMedia?.length - 1);
            this.sidebarMedia[index].scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start'
            });
          }
       }

       toggleButton ({enabledOrDisabled, button}) {
          if (enabledOrDisabled === 'disabled') {
            button.setAttribute('aria-disabled', true);
            button.setAttribute('disabled', true);
          } else {
            button.removeAttribute('aria-disabled');
            button.removeAttribute('disabled');
          }

       }

        onButtonClick(direction) {
          
          if (direction === "previous") {
            if (this.currentSidebarIndex === 0) return;
            const nextIndex = this.currentSidebarIndex - this.scrollBy;
            this.toggleButton({enabledOrDisabled: 'enabled', button: this.elements.nextButton});
            if (nextIndex <= 0 ) {
              this.scrollToIndex(0);
              this.toggleButton({enabledOrDisabled: 'disabled', button: this.elements.prevButton});
            } else {
              this.scrollToIndex(nextIndex);
              this.toggleButton({enabledOrDisabled: 'enabled', button: this.elements.prevButton});
            }
          }
          if (direction === "next") {
            if (this.currentSidebarIndex >= this?.sidebarMedia?.length - 1) return;
            this.toggleButton({enabledOrDisabled: 'enabled', button: this.elements.prevButton});
            const nextIndex = this.currentSidebarIndex + this.scrollBy;
            const lastIndex = this.sidebarMedia?.length - 1;
            if (nextIndex >= this?.sidebarMedia?.length - 1) {
              this.scrollToIndex(nextIndex);
              this.toggleButton({enabledOrDisabled: 'enabled', button: this.elements.nextButton});
            } else {
              this.toggleButton({enabledOrDisabled: 'disabled', button: this.elements.nextButton});
              this.scrollToIndex(lastIndex);  
            }
          }
        };

        updateIndicator(mediaId) {
          const media = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
          const currentMediaIndex = media.findIndex((item) => item.dataset.target === mediaId);
          const dots = this.elements.dots.querySelectorAll('[data-dot-index]');
          const thumbs = this.elements.sideThumbnails.querySelectorAll(['[data-thumb-index]']);
          dots.forEach((indicator, idx) => {
            indicator.classList.toggle('slider-counter__link--active', idx === currentMediaIndex);
            indicator.removeAttribute('aria-current');
          });
          dots[currentMediaIndex].setAttribute('aria-current', 'true');
          thumbs.forEach((indicator, idx) => {
            indicator.classList.toggle('slider-counter__link--active', idx === currentMediaIndex);
            indicator.removeAttribute('aria-current');
          });
          thumbs[currentMediaIndex].setAttribute('aria-current', 'true');
        }
  
        setActiveMedia(mediaId, prepend) {
          const activeMedia =
            this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
            this.elements.viewer.querySelector('[data-media-id]');

          if (!activeMedia) {
            return;
          }
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia?.classList?.add('is-active');
  
          if (prepend) {
            activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
  
            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }
  
            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }
  
          this.preventStickyHeader();

          window.setTimeout(() => {
            if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            }
            const activeMediaRect = activeMedia.getBoundingClientRect();
            // Don't scroll if the image is already in view
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
          // this.playActiveMedia(activeMedia);
  
          if (!this.elements.thumbnails) return;
          const activeThumbnail = this.elements.sideThumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.updateIndicator(mediaId);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
  
        setActiveThumbnail(thumbnail) {
          if (!this.elements.sideThumbnails || !thumbnail) return;
  
          this.elements.sideThumbnails
            .querySelectorAll('button')
            .forEach((element) => element.removeAttribute('aria-current'));
          thumbnail.querySelector('button').setAttribute('aria-current', true);
          if (this?.elements?.thumbnails?.isSlideVisible && this?.elements?.thumbnails?.isSlideVisible(thumbnail, 10)) return;

          thumbnail.parentElement.scrollTo({top: thumbnail.offsetTop, behavior: 'smooth'});
        }
  
        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector('.product__modal-opener--image img');
          if (!image) return;
          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };
          image.src = image.src;
        }
  
        playActiveMedia(activeItem) {
          window.pauseAllMedia();
          const deferredMedia = activeItem.querySelector('.deferred-media');
          if (deferredMedia) deferredMedia.loadContent(false);
        }
  
        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
  
        removeListSemantic() {
          if (!this.elements.viewer.slider) return;
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this?.elements?.viewer?.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    );
  }